import {default as axios} from "axios";
import {StatusCodes} from "http-status-codes";
import { withSocialChannelHeaders } from "../social-auth/social-channel";
import { useIsSocialMode } from "../social-auth/social-mode-context";
import {useBaseApi} from "../useBaseApi";

export function useEmployeeRepository() {
    const isSocialMode = useIsSocialMode();
    const {search} = useBaseApi();

    const createEmployee = async (body) => {
        return await axios.post(process.env.API + "/employee", body, {
            headers: withSocialChannelHeaders({"Content-Type": "application/json"}, isSocialMode),
        });
    }

    const searchEmployee = async (filters) => {
        let response = await search("/employee", filters);

        if(response.status === StatusCodes.OK)
        {
            return response.data;
        }

        return null;
    }

    return {createEmployee, searchEmployee};
}